/**
 * Returns the Curacao states list to populate the select item.
 */
 export function gluky_addressfield_cr_states_list() {
    let temporalStates = [];
    const states =
    {
        '14' : 'San José',
        '15' : 'Alajuela',
        '16' : 'Cartago',
        '17' : 'Heredia',
        '18' : 'Guanacaste',
        '19' : 'Puntarenas',
        '20' : 'Limón',
    }
    
    Object.keys(states).map((res) => {
        temporalStates = [
        ...temporalStates,
        {
            name: states[res],
            code: res,
        },
        ];
    });
    return temporalStates;
    }
    
    /**
     * Returns the Curacao cities list by state code to populate the select item.
     *
     * @param $state_code
     *   The DANE state code
     * @return
     */
    export function gluky_addressfield_cr_cities_list($state_code) {
    let temporalCities = [];
    const $data = {
        '14':{
            '14014' : 'San José',
            '14015' : 'Escazú',
            '14016' : 'Desamparados',
            '14017' : 'Puriscal',
            '14018' : 'Tarrazú',
            '14019' : 'Aserrí',
            '14020' : 'Mora',
            '14021' : 'Goicoechea',
            '14022' : 'Santa Ana',
            '14023' : 'Alajuelita',
            '14024' : 'Vázquez de Coronado',
            '14025' : 'Acosta',
            '14026' : 'Tibás',
            '14027' : 'Moravia',
            '14028' : 'Montes de Oca',
            '14029' : 'Turrubares',
            '14030' : 'Dota',
            '14031' : 'Curridabat',
            '14032' : 'Pérez Zeledón',
            '14033' : 'León Cortés',
        },
        '15':{
            '15015' : 'Alajuela',
            '15016' : 'San Ramón',
            '15017' : 'Grecia',
            '15018' : 'San Mateo',
            '15019' : 'Atenas',
            '15020' : 'Naranjo',
            '15021' : 'Palmares',
            '15022' : 'Poás',
            '15023' : 'Orotina',
            '15024' : 'San Carlos',
            '15025' : 'Zarcero',
            '15026' : 'Valverde Vega',
            '15027' : 'Upala',
            '15028' : 'Los Chiles',
            '15029' : 'Guatuso',
        },
        '16':{
            '16016' : 'Cartago',
            '16017' : 'Paraíso',
            '16018' : 'La Unión',
            '16019' : 'Jiménez',
            '16020' : 'Turrialba',
            '16021' : 'Alvarado',
            '16022' : 'Oreamuno',
            '16023' : 'El Guarco',
        },
        '17':{
            '17017' : 'Heredia',
            '17018' : 'Barva',
            '17019' : 'Santo Domingo',
            '17020' : 'Santa Bárbara',
            '17021' : 'San Rafael',
            '17022' : 'San Isidro',
            '17023' : 'Belén',
            '17024' : 'Flores',
            '17025' : 'San Pablo',
            '17026' : 'Sarapiquí',
        }, 
        '18':{
            '18018' : 'Liberia',
            '18019' : 'Nicoya',
            '18020' : 'Santa Cruz',
            '18021' : 'Bagaces',
            '18022' : 'Carrillo',
            '18023' : 'Cañas',
            '18024' : 'Abangares',
            '18025' :'Tilarán',
            '18026' : 'Nandayure',
            '18027' : 'La Cruz',
            '18028' : 'Hojancha',
        },
        '19':{
            '19019' : 'Puntarenas',
            '19020' : 'Esparza',
            '19021' : 'Buenos Aires',
            '19022' : 'Montes de Oro',
            '19023' : 'Osa',
            '19024' : 'Quepos',
            '19025' : 'Golfito',
            '19026' : 'Coto Brus',
            '19027' : 'Parrita',
            '19028' : 'Corredores',
            '19029' : 'Garabito',
        },
        '20':{
            '20020' : 'Limón',
            '20021' : 'Pococí',
            '20022' : 'Siquirres',
            '20023' : 'Talamanca',
            '20024' : 'Matina',
            '20025' : 'Guácimo',
        },
    }
    const cities = $data[$state_code] ? $data[$state_code] : null;
    Object.keys(cities).map((citie) => {
        temporalCities = [
        ...temporalCities,
        {
            name: cities[citie],
            code: citie,
        },
        ];
    });
    return temporalCities;
}
    
    